/* eslint-disable no-shadow */

export enum AllianceEnum {
    DIDI="Didi",
    BODEGA="Bodega Aurrera",
    WALMART="Walmart",
}

export enum AllianceUrlEnum {
    DIDI="didi",
    BODEGA="bodega-aurrera",
    WALMART="walmart",
}

export const AllianceObject = {
    [AllianceUrlEnum.DIDI]: AllianceEnum.DIDI,
    [AllianceUrlEnum.BODEGA]: AllianceEnum.BODEGA,
    [AllianceUrlEnum.WALMART]: AllianceEnum.WALMART,
};

export const CATALOG_ALLIANCES = [
    AllianceEnum.BODEGA,
    AllianceEnum.WALMART
];

export const CATALOG_ALLIANCES_URLS = [
    AllianceUrlEnum.BODEGA,
    AllianceUrlEnum.WALMART
];

const AllianceColorsObject = {
    [AllianceEnum.DIDI]: {
        "25": "#ffece7ff",
        "25_rgb": "255, 236, 231",
        "contrast_25": "#000000",
        "contrast_25_rgb": "0, 0, 0",
        "50": "#FFDCD2",
        "50_rgb": "255, 220, 210",
        "contrast_50": "#000000",
        "contrast_50_rgb": "0, 0, 0",
        "300": "#FC4C02",
        "300_rgb": "252, 76, 2",
        "contrast_300": "#ffffff",
        "contrast_300_rgb": "255, 255, 255",
    },
    [AllianceEnum.BODEGA]: {
        "25": "#EBF9F1",
        "25_rgb": "235, 249, 241",
        "contrast_25": "#000000",
        "contrast_25_rgb": "0, 0, 0",
        "50": "#D7F4E3",
        "50_rgb": "215, 244, 227",
        "contrast_50": "#000000",
        "contrast_50_rgb": "0, 0, 0",
        "300": "#2C981D",
        "300_rgb": "44, 152, 29",
        "contrast_300": "#ffffff",
        "contrast_300_rgb": "255, 255, 255",
        "400": "#177E0E",
        "400_rgb": "23, 126, 14",
        "contrast_400": "#ffffff",
        "contrast_400_rgb": "255, 255, 255",
        "secondary_600": "#F2D138",
        "secondary_600_rgb": "242, 209, 56",
        "secondary_contrast_600": "#177E0E",
        "secondary_contrast_600_rgb": "23, 126, 14",
    },
    [AllianceEnum.WALMART]: {
        "25": "#f0f8ffff",
        "25_rgb": "240, 248, 255",
        "contrast_25": "#000000",
        "contrast_25_rgb": "0, 0, 0",
        "50": "#E6F1FC",
        "50_rgb": "230, 241, 252",
        "contrast_50": "#000000",
        "contrast_50_rgb": "0, 0, 0",
        "300": "#0071DC",
        "300_rgb": "0, 113, 220",
        "contrast_300": "#ffffff",
        "contrast_300_rgb": "255, 255, 255",
        "400": "#004F9A",
        "400_rgb": "0, 79, 153",
        "contrast_400": "#ffffff",
        "contrast_400_rgb": "255, 255, 255",
        "secondary_600": "#F2D138",
        "secondary_600_rgb": "242, 209, 56",
        "secondary_contrast_600": "#004F9A",
        "secondary_contrast_600_rgb": "0, 79, 154",
    },
};

export const getAlliance = (url: AllianceUrlEnum) => {
    return AllianceObject[url] ?? null;
};

export const getAllianceUrl = (alliance: AllianceEnum) => {
    const InvertedAllianceObject = Object.fromEntries(
        Object.entries(AllianceObject).map(([key, value]) => [value, key])
    );

    return InvertedAllianceObject[alliance] ?? null;
};

export const getAllianceColor = (alliance: AllianceEnum, color: string) => {
    const allianceColors = AllianceColorsObject[alliance];
    if (!allianceColors) return null;
    return allianceColors[color as keyof typeof allianceColors] || null;
};

export const getCatalogBaseUrl = (alliance?: AllianceEnum) => {
    return alliance && CATALOG_ALLIANCES.includes(alliance)
        ? `/${getAllianceUrl(alliance)}/catalogo`
        : "/catalogo";
};
